import apiInstance from 'src/apis/config/axiosConfig';

export interface TenantBatchDeleteResult {
  success: boolean;
  deleted: string[];
  failed: Array<{id: string; message: string}>;
  deletedCount: number;
  failedCount: number;
}

/**
 * Thin tenant helpers for endpoints the OpenAPI client does not yet expose.
 */
export const tenantClient = {
  batchDelete: (tenantIds: string[]) =>
    apiInstance.post<TenantBatchDeleteResult>('/tenant/tenants/batch-delete', {
      tenantIds,
    }),
};
